import { Component, inject, Input, OnInit } from '@angular/core';
import { TaskAnalysisService } from '@app/task/task-analysis/task-analysis.service';
import { getEnvaluateColor } from '@shared/utils/utils';
import { TaskPackDetail } from '@shared/model/task.models';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'fl-task-pack-change',
  templateUrl: './task-pack-change.component.html',
  styleUrls: ['./task-pack-change.component.scss'],
  standalone: false,
})
export class TaskPackChangeComponent implements OnInit {
  private drawerRef = inject(NzDrawerRef);

  // nzContentParams 动态传参组件（ng-zorro 22 对 signal input 跳过赋值且类型不接受），回退装饰器输入
  @Input() taskAnalysisSrv: TaskAnalysisService;

  getEnvaluateColor = getEnvaluateColor;

  Number = Number;

  ngOnInit(): void {}

  changeTask(task: TaskPackDetail) {
    this.drawerRef.close(task);
  }

  fmtContent(e) {
    console.log(e);
  }
}
